import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';

function SelectList(props) {
  const { label, gridArea, options, required, ref, id, ...rests } = props;
  
  return (
    <Root gridArea={gridArea} ref={ref} {...rests}>
      <label htmlFor={id}>{label}</label>
      <select required={required} id={id} name={id} defaultValue="--">
        <option value="--" disabled>--</option>
        {
          options && options.length >= 1 && options.map( option => (
            <option value={option} key={option}>{option}</option>
          ))
        }
      </select>
    </Root>
  )
}

SelectList.propTypes = {
  label: PropTypes.string, 
  options: PropTypes.array, 
  gridArea: PropTypes.string, 
  required: PropTypes.bool,
  id: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]), 
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: ${props => props.gridArea};

  label {
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-align: left;
    ${vw('font-size', 14, 12)}
    ${vw('line-height', 17, 19)}
    ${vw('letter-spacing', 0.06)}
    ${vw('margin-bottom', 5, 3)}
  }
  
  select {
    border: 1px solid #E1E1E1;
    box-sizing: border-box;
    color: #747474;
    ${vw('height', 30)}
    ${vw('font-size', 8, 12)}
    ${vw('line-height', 10, 16)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
`;

export default SelectList

